<template>
  <div :class="{formGroup: true, isRequired: itemSetting.action.isRequired}">
    <div class="label" :style="labelStyle">
      <p>{{itemSetting.action.label[lang]}}</p>
      <span v-if="passed !== null && passed === false" class="validateMessage">({{locale.required}})</span>
    </div>
    <div :class="{rateBox: true, lessItem: itemSetting.action.max < 7}"><div class="rateList">
      <div v-for="(rate, index) in itemSetting.action.max" :key="index" :class="{listItem: true, rate: true, checked: index + 1 <= value.value}">
        <input type="radio" :name="`rate_${id}`" :id="`rate_${id}_${index}`" :value="index + 1" v-model="value.value">
        <label :for="`rate_${id}_${index}`">
          <svg
            v-if="itemSetting.action.type === 'heart'"
            :fill="rateColor(index + 1 <= value.value)"
            xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="28px" height="28px"><path d="M376,30c-27.783,0-53.255,8.804-75.707,26.168c-21.525,16.647-35.856,37.85-44.293,53.268c-8.437-15.419-22.768-36.621-44.293-53.268C189.255,38.804,163.783,30,136,30C58.468,30,0,93.417,0,177.514c0,90.854,72.943,153.015,183.369,247.118c18.752,15.981,40.007,34.095,62.099,53.414C248.38,480.596,252.12,482,256,482s7.62-1.404,10.532-3.953c22.094-19.322,43.348-37.435,62.111-53.425C439.057,330.529,512,268.368,512,177.514C512,93.417,453.532,30,376,30z"/></svg>
          <svg
            v-else-if="itemSetting.action.type === 'smile'"
            :fill="rateColor(index + 1 <= value.value)"
            xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34.25 34.25" width="28px" height="28px"><path d="M17.125,0C7.668,0,0,7.667,0,17.125S7.668,34.25,17.125,34.25c9.459,0,17.125-7.667,17.125-17.125S26.584,0,17.125,0zM23.445,11.422c1.354,0,2.453,1.099,2.453,2.453s-1.1,2.453-2.453,2.453c-1.354,0-2.453-1.099-2.453-2.453S22.091,11.422,23.445,11.422z M10.804,11.422c1.355,0,2.453,1.099,2.453,2.453s-1.098,2.453-2.453,2.453c-1.354,0-2.453-1.099-2.453-2.453S9.451,11.422,10.804,11.422z M26.365,23.079c-2.098,3.046-5.553,4.864-9.24,4.864c-3.689,0-7.145-1.818-9.24-4.865c-0.47-0.682-0.297-1.616,0.386-2.086c0.683-0.471,1.616-0.297,2.086,0.386c1.536,2.233,4.067,3.565,6.769,3.565s5.231-1.332,6.771-3.565c0.47-0.681,1.402-0.854,2.086-0.385C26.662,21.463,26.834,22.396,26.365,23.079z"/></svg>
          <svg
            v-else-if="itemSetting.action.type === 'circle'"
            :fill="rateColor(index + 1 <= value.value)"
            xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="28px" height="28px"><path d="M256,0C115.39,0,0,115.39,0,256s115.39,256,256,256s256-115.39,256-256S396.61,0,256,0z"/></svg>
          <svg
            v-else-if="itemSetting.action.type === 'square'"
            :fill="rateColor(index + 1 <= value.value)"
            xmlns="http://www.w3.org/2000/svg" viewBox="0 0 506.1 506.1" width="28px" height="28px"><path d="m489.609 0h-473.118c-9.108 0-16.491 7.383-16.491 16.491v473.118c0 9.107 7.383 16.491 16.491 16.491h473.119c9.107 0 16.49-7.383 16.49-16.491v-473.118c0-9.108-7.383-16.491-16.491-16.491z"/></svg>
          <svg
            v-else
            :fill="rateColor(index + 1 <= value.value)"
            xmlns="http://www.w3.org/2000/svg" viewBox="0 -10 511.99143 511" width="28px" height="28px"><path d="m510.652344 185.882812c-3.371094-10.367187-12.566406-17.707031-23.402344-18.6875l-147.796875-13.417968-58.410156-136.75c-4.3125-10.046875-14.125-16.53125-25.046875-16.53125s-20.738282 6.484375-25.023438 16.53125l-58.410156 136.75-147.820312 13.417968c-10.835938 1-20.011719 8.339844-23.402344 18.6875-3.371094 10.367188-.257813 21.738282 7.9375 28.925782l111.722656 97.964844-32.941406 145.085937c-2.410156 10.667969 1.730468 21.699219 10.582031 28.097656 4.757813 3.457031 10.347656 5.183594 15.957031 5.183594 4.820313 0 9.644532-1.28125 13.953125-3.859375l127.445313-76.203125 127.421875 76.203125c9.347656 5.585938 21.101562 5.074219 29.933593-1.324219 8.851563-6.398437 12.992188-17.429687 10.582032-28.097656l-32.941406-145.085937 111.722656-97.964844c8.191406-7.1875 11.308594-18.535156 7.9375-28.925782zm-252.203125 223.722657"/></svg>
        </label>
      </div></div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'Rate',
  props: [
    'id',
    'itemSetting',
    'lang',
    'locale',
    'storageData',
    'getSubmitData'
  ],
  computed: {
    labelStyle () {
      const fontSize = this.itemSetting.action.labelFontSize
      return {
        ...fontSize && fontSize !== 'default' && {
          fontSize: `${fontSize}px`
        }
      }
    },
    value: {
      get () {
        const data = typeof (this.getSubmitData.find(x => x.id === this.id)) === 'undefined' ? '' : this.getSubmitData.find(x => x.id === this.id).value
        return data
      },
      set (value) {
        this.setSubmitData(value)
      }
    },
    passed () {
      return this.getSubmitData && this.getSubmitData.find(x => x.id === this.id)
        ? this.getSubmitData.find(x => x.id === this.id).passed
        : null
    }
  },
  watch: {
    value: {
      deep: true,
      handler (value) {
        if (value) {
          this.setSubmitData(value)
        }
      }
    }
  },
  data () {
    return {
      message: 'is required'
    }
  },
  methods: {
    rateColor (checked) {
      // const color = checked ? this.itemSetting.action.color : ''
      return checked ? this.itemSetting.action.color : '#cacaca'
    },
    setSubmitData (value) {
      const passed = !this.itemSetting.action.isRequired ? null : value.value !== ''
      const data = {
        id: this.id,
        value: value,
        passed: passed
      }
      this.$emit('setValue', data)
    }
  }
}
</script>
